import React from "react";
import {
  Users,
  UserCheck,
  UserPlus,
  CalendarOff,
  FileText,
} from "lucide-react";

// Map string names from JSON to actual Lucide Icons
const iconMap = {
  Users: Users,
  UserCheck: UserCheck,
  UserPlus: UserPlus,
  CalendarOff: CalendarOff,
  FileText: FileText,
};

export default function StatCard({
  title,
  value,
  iconName,
  iconBg,
  iconColor,
}) {
  // Select the correct icon dynamically based on the prop
  const IconComponent = iconMap[iconName] || Users;

  return (
    // min-w-0 ensures the card never stretches past the screen width
    <div className="bg-white rounded-xl p-4 xl:p-5 border border-slate-200 shadow-sm flex flex-col justify-center min-w-0">
      <div className="flex items-center gap-3 xl:gap-4 min-w-0">
        {/* Dynamic Icon - Resizes slightly on smaller screens */}
        <div
          className={`w-10 h-10 xl:w-12 xl:h-12 rounded-xl flex items-center justify-center shrink-0 ${iconBg}`}
        >
          <IconComponent className={`w-5 h-5 xl:w-6 xl:h-6 ${iconColor}`} />
        </div>

        {/* Titles & Values - truncate prevents text from breaking the card layout */}
        <div className="flex flex-col min-w-0 flex-1">
          <h3 className="text-xs xl:text-sm font-semibold text-slate-600 mb-0.5 truncate">
            {title}
          </h3>
          <span className="text-xl xl:text-3xl font-bold text-slate-900 tracking-tight truncate">
            {value}
          </span>
        </div>
      </div>
    </div>
  );
}
